import { deleteCookie } from '@parentScripts/components/cookie/deleteCookie';

export default function initCommon() {
  deleteCookie('PREF');
}
